import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c96973f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c96973f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96973f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExploreCard: require('/workspace/components/ExploreCard.vue').default})
